import { render, staticRenderFns } from "./detail_uboRuler.vue?vue&type=template&id=fdba9e46&scoped=true&"
import script from "./detail_uboRuler.vue?vue&type=script&lang=js&"
export * from "./detail_uboRuler.vue?vue&type=script&lang=js&"
import style0 from "./detail_uboRuler.vue?vue&type=style&index=0&id=fdba9e46&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdba9e46",
  null
  
)

export default component.exports